<template>
  <el-container style="height:100vh;">
    <el-aside width="220px">
      <Sidebar />
    </el-aside>
    <el-container>
      <el-header style="height:60px;">
        <Header />
      </el-header>
      <el-main style="overflow:auto;">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import Sidebar from './Sidebar.vue'
import Header from './Header.vue'
export default {
  components: { Sidebar, Header }
}
</script>
